export default "__VITE_ASSET__6b000e40__"